import React from "react";
import BlinkitToZomatoMigrationUpload from "../../../components/DriverServiceMigration/BlinkitToZomatoMigration";

const BlinkitToZomatoMigration = (props) => {
  return <BlinkitToZomatoMigrationUpload />;
};

export default BlinkitToZomatoMigration;
